export default "__VITE_ASSET__K$nYXF5w__"